var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _rect5, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 388H396V406H78V388Z",
    fill: "url(#paint0_linear_106_1020)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 296H396V314H297V296Z",
    fill: "url(#paint1_linear_106_1020)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 213H396V231H297V213Z",
    fill: "url(#paint2_linear_106_1020)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 254H396V272H297V254Z",
    fill: "url(#paint3_linear_106_1020)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 443H396V461H78V443Z",
    fill: "url(#paint4_linear_106_1020)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#F7DF1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.354 41.1818H127.899V90.2727C127.876 94.7727 126.922 98.6477 125.036 101.898C123.149 105.125 120.513 107.614 117.126 109.364C113.763 111.091 109.842 111.955 105.365 111.955C101.274 111.955 97.5923 111.227 94.3196 109.773C91.0696 108.295 88.4901 106.114 86.581 103.227C84.6719 100.341 83.7173 96.75 83.7173 92.4545H96.2969C96.3196 94.3409 96.7287 95.9659 97.5241 97.3295C98.3423 98.6932 99.4673 99.7386 100.899 100.466C102.331 101.193 103.979 101.557 105.842 101.557C107.865 101.557 109.581 101.136 110.99 100.295C112.399 99.4318 113.467 98.1591 114.195 96.4773C114.945 94.7955 115.331 92.7273 115.354 90.2727V41.1818ZM179.564 60.375C179.246 57.3977 177.905 55.0795 175.541 53.4205C173.2 51.7614 170.155 50.9318 166.405 50.9318C163.768 50.9318 161.507 51.3295 159.621 52.125C157.734 52.9205 156.291 54 155.291 55.3636C154.291 56.7273 153.78 58.2841 153.757 60.0341C153.757 61.4886 154.087 62.75 154.746 63.8182C155.428 64.8864 156.348 65.7955 157.507 66.5455C158.666 67.2727 159.95 67.8864 161.359 68.3864C162.768 68.8864 164.189 69.3068 165.621 69.6477L172.166 71.2841C174.803 71.8977 177.337 72.7273 179.768 73.7727C182.223 74.8182 184.416 76.1364 186.348 77.7273C188.303 79.3182 189.848 81.2386 190.984 83.4886C192.121 85.7386 192.689 88.375 192.689 91.3977C192.689 95.4886 191.643 99.0909 189.553 102.205C187.462 105.295 184.439 107.716 180.484 109.466C176.553 111.193 171.791 112.057 166.2 112.057C160.768 112.057 156.053 111.216 152.053 109.534C148.075 107.852 144.962 105.398 142.712 102.17C140.484 98.9432 139.28 95.0114 139.098 90.375H151.541C151.723 92.8068 152.473 94.8295 153.791 96.4432C155.109 98.0568 156.825 99.2614 158.939 100.057C161.075 100.852 163.462 101.25 166.098 101.25C168.848 101.25 171.257 100.841 173.325 100.023C175.416 99.1818 177.053 98.0227 178.234 96.5455C179.416 95.0455 180.018 93.2955 180.041 91.2955C180.018 89.4773 179.484 87.9773 178.439 86.7955C177.393 85.5909 175.928 84.5909 174.041 83.7955C172.178 82.9773 169.996 82.25 167.496 81.6136L159.553 79.5682C153.803 78.0909 149.257 75.8523 145.916 72.8523C142.598 69.8295 140.939 65.8182 140.939 60.8182C140.939 56.7045 142.053 53.1023 144.28 50.0114C146.53 46.9205 149.587 44.5227 153.45 42.8182C157.314 41.0909 161.689 40.2273 166.575 40.2273C171.53 40.2273 175.871 41.0909 179.598 42.8182C183.348 44.5227 186.291 46.8977 188.428 49.9432C190.564 52.9659 191.666 56.4432 191.734 60.375H179.564Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 171,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#F7DF1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.071 265.545V260.977C110.692 260.977 112.51 260.455 113.526 259.409C114.541 258.364 115.048 256.674 115.048 254.341V249.318C115.048 246.515 115.435 244.273 116.207 242.591C116.995 240.894 118.086 239.614 119.48 238.75C120.889 237.886 122.556 237.311 124.48 237.023C126.404 236.735 128.51 236.591 130.798 236.591V243.818C129.01 243.818 127.647 244.053 126.707 244.523C125.783 244.977 125.154 245.689 124.821 246.659C124.488 247.614 124.321 248.826 124.321 250.295V256.932C124.321 258.083 124.109 259.182 123.685 260.227C123.26 261.258 122.473 262.174 121.321 262.977C120.17 263.765 118.526 264.394 116.389 264.864C114.253 265.318 111.48 265.545 108.071 265.545ZM130.798 294.114C128.51 294.114 126.404 293.97 124.48 293.682C122.556 293.394 120.889 292.818 119.48 291.955C118.086 291.091 116.995 289.811 116.207 288.114C115.435 286.432 115.048 284.189 115.048 281.386V276.341C115.048 274.008 114.541 272.318 113.526 271.273C112.51 270.227 110.692 269.705 108.071 269.705V265.136C111.48 265.136 114.253 265.371 116.389 265.841C118.526 266.295 120.17 266.924 121.321 267.727C122.473 268.515 123.26 269.432 123.685 270.477C124.109 271.508 124.321 272.606 124.321 273.773V280.409C124.321 281.864 124.488 283.068 124.821 284.023C125.154 284.992 125.783 285.705 126.707 286.159C127.647 286.629 129.01 286.864 130.798 286.864V294.114ZM108.071 269.705V260.977H116.23V269.705H108.071ZM141.804 284.591C140.304 284.591 139.016 284.061 137.94 283C136.88 281.924 136.349 280.636 136.349 279.136C136.349 277.652 136.88 276.379 137.94 275.318C139.016 274.258 140.304 273.727 141.804 273.727C143.259 273.727 144.531 274.258 145.622 275.318C146.713 276.379 147.259 277.652 147.259 279.136C147.259 280.136 147.001 281.053 146.486 281.886C145.986 282.705 145.327 283.364 144.509 283.864C143.69 284.348 142.789 284.591 141.804 284.591ZM155.207 249.091H164.889V285.727C164.889 288.424 164.359 290.606 163.298 292.273C162.238 293.939 160.715 295.159 158.73 295.932C156.76 296.705 154.404 297.091 151.662 297.091C151.329 297.091 151.01 297.083 150.707 297.068C150.389 297.068 150.056 297.061 149.707 297.045V289.477C149.965 289.492 150.192 289.5 150.389 289.5C150.571 289.515 150.768 289.523 150.98 289.523C152.541 289.523 153.632 289.189 154.253 288.523C154.889 287.871 155.207 286.886 155.207 285.568V249.091ZM160.026 244.591C158.601 244.591 157.374 244.114 156.344 243.159C155.313 242.189 154.798 241.03 154.798 239.682C154.798 238.348 155.313 237.205 156.344 236.25C157.374 235.28 158.601 234.795 160.026 234.795C161.48 234.795 162.715 235.28 163.73 236.25C164.76 237.205 165.276 238.348 165.276 239.682C165.276 241.03 164.76 242.189 163.73 243.159C162.715 244.114 161.48 244.591 160.026 244.591ZM201.69 259.045L192.827 259.591C192.675 258.833 192.349 258.152 191.849 257.545C191.349 256.924 190.69 256.432 189.872 256.068C189.069 255.689 188.107 255.5 186.986 255.5C185.486 255.5 184.221 255.818 183.19 256.455C182.16 257.076 181.645 257.909 181.645 258.955C181.645 259.788 181.978 260.492 182.645 261.068C183.312 261.644 184.455 262.106 186.077 262.455L192.395 263.727C195.789 264.424 198.319 265.545 199.986 267.091C201.652 268.636 202.486 270.667 202.486 273.182C202.486 275.47 201.812 277.477 200.463 279.205C199.13 280.932 197.296 282.28 194.963 283.25C192.645 284.205 189.971 284.682 186.94 284.682C182.319 284.682 178.637 283.72 175.895 281.795C173.168 279.856 171.569 277.22 171.099 273.886L180.622 273.386C180.91 274.795 181.607 275.871 182.713 276.614C183.819 277.341 185.236 277.705 186.963 277.705C188.66 277.705 190.024 277.379 191.054 276.727C192.099 276.061 192.63 275.205 192.645 274.159C192.63 273.28 192.259 272.561 191.531 272C190.804 271.424 189.683 270.985 188.168 270.682L182.122 269.477C178.713 268.795 176.175 267.614 174.509 265.932C172.857 264.25 172.031 262.106 172.031 259.5C172.031 257.258 172.637 255.326 173.849 253.705C175.077 252.083 176.796 250.833 179.009 249.955C181.236 249.076 183.842 248.636 186.827 248.636C191.236 248.636 194.705 249.568 197.236 251.432C199.781 253.295 201.266 255.833 201.69 259.045ZM228.923 265.136V269.705C226.317 269.705 224.499 270.227 223.469 271.273C222.454 272.318 221.946 274.008 221.946 276.341V281.386C221.946 284.189 221.552 286.432 220.764 288.114C219.991 289.811 218.901 291.091 217.491 291.955C216.098 292.818 214.438 293.394 212.514 293.682C210.605 293.97 208.499 294.114 206.196 294.114V286.864C207.984 286.864 209.34 286.629 210.264 286.159C211.204 285.705 211.84 284.992 212.173 284.023C212.507 283.068 212.673 281.864 212.673 280.409V273.773C212.673 272.606 212.885 271.508 213.31 270.477C213.734 269.432 214.522 268.515 215.673 267.727C216.825 266.924 218.469 266.295 220.605 265.841C222.741 265.371 225.514 265.136 228.923 265.136ZM206.196 236.591C208.499 236.591 210.605 236.735 212.514 237.023C214.438 237.311 216.098 237.886 217.491 238.75C218.901 239.614 219.991 240.894 220.764 242.591C221.552 244.273 221.946 246.515 221.946 249.318V254.341C221.946 256.674 222.454 258.364 223.469 259.409C224.499 260.455 226.317 260.977 228.923 260.977V265.545C225.514 265.545 222.741 265.318 220.605 264.864C218.469 264.394 216.825 263.765 215.673 262.977C214.522 262.174 213.734 261.258 213.31 260.227C212.885 259.182 212.673 258.083 212.673 256.932V250.295C212.673 248.826 212.507 247.614 212.173 246.659C211.84 245.689 211.204 244.977 210.264 244.523C209.34 244.053 207.984 243.818 206.196 243.818V236.591ZM228.923 260.977V269.705H220.764V260.977H228.923Z",
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1020",
    x: 71.7188,
    y: 40.2266,
    width: 124.969,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_1020",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9CA32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_1020",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9CA32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_1020",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9CA32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_1020",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9CA32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_1020",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9CA32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.ff11fd546647c8e4eeab7f07d90156a8.svg";
export { ForwardRef as ReactComponent };